import { Injectable, inject } from '@angular/core';
import { MiDetails, MiQuote, MiQuoteResponse } from '../../disclosure/models/mi-quote.model';
import { HttpClient } from '@angular/common/http';
import { Subject, catchError, finalize, throwError } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { MortgageType } from '../../cmg-1003/models';
import { Cmg1003LookupsQuery } from '../../loan-state';
import { APP_ENV } from 'apps/cmg-clear2-ui/src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class MiQuoteService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environment = inject(APP_ENV);
  private readonly _spinnerService = inject(SpinnerService);
  private readonly _lookupsQuery = inject(Cmg1003LookupsQuery);

  resetPmiType$ = new Subject<boolean>();

  getMIQuotes(miQuoteRequest: MiQuote) {
    const url = `${this._environment?.retail?.apiUrl}/miquote/getmiquotes`;
    return this._httpClient.post<MiQuoteResponse>(url, miQuoteRequest).pipe(catchError(this._handleError));
  }

  updateMiDetails = (miDetails: MiDetails) =>
    this._httpClient.put(`${this._environment?.retail?.apiUrl}/miquote/updatemidetails`, miDetails).pipe(
      catchError(this._handleError),
      finalize(() => {
        this._spinnerService.hide();
      }),
    );

  isMiQuoteDisabled(ltv: number, mortgageType: MortgageType, loanProgramCode: string): boolean {
    if (!loanProgramCode) {
      return false;
    }

    const loanProgram = this._lookupsQuery.getValue().loanPrograms.find((program) => program.loanProgramCode === loanProgramCode);
    const isNonQM = loanProgram?.isNonQM ?? false;

    if (isNonQM) {
      return true;
    }

    return !(ltv > 80 && (mortgageType === MortgageType.conventional || (mortgageType === MortgageType.heloc && loanProgramCode?.startsWith('801'))));
  }

  private _handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(errorMessage);
  }
}
